import { useNavigate } from "react-router-dom";
import MarketingNav from "./MarketingNav";

export default function ComingSoon() {
  const navigate = useNavigate();

  return (
    <div style={{
      minHeight: "100vh", background: "#fff",
      fontFamily: "'DM Sans', 'Segoe UI', sans-serif",
      display: "flex", flexDirection: "column",
    }}>

      <MarketingNav />

      {/* Centered content */}
      <div style={{
        flex: 1, display: "flex", flexDirection: "column",
        alignItems: "center", justifyContent: "center",
        padding: "60px 24px", textAlign: "center",
      }}>

        {/* Eyebrow */}
        <div style={{
          display: "inline-flex", alignItems: "center", gap: 8,
          background: "#EFF6FF", border: "1px solid #BFDBFE",
          borderRadius: 20, padding: "6px 16px",
          fontSize: 13, fontWeight: 700, color: "#2563EB",
          letterSpacing: 0.3, marginBottom: 28,
        }}>
          <span style={{ fontSize: 15 }}>🚧</span> Under construction
        </div>

        {/* Headline */}
        <h1 style={{
          fontSize: "clamp(42px, 8vw, 72px)",
          fontWeight: 900, letterSpacing: -2,
          color: "#0F172A", lineHeight: 1.1,
          margin: "0 0 12px",
        }}>
          Coming{" "}
          <span style={{ position: "relative", display: "inline-block" }}>
            soon
            <svg
              viewBox="0 0 120 12" fill="none"
              style={{ position: "absolute", bottom: -6, left: 0, width: "100%", height: 10, overflow: "visible" }}
            >
              <path d="M4 8 Q30 2 60 8 Q90 14 116 6" stroke="#06B6D4" strokeWidth="3.5" strokeLinecap="round" fill="none" />
            </svg>
          </span>
          .
        </h1>

        {/* Subtext */}
        <p style={{
          fontSize: 18, color: "#64748B", fontWeight: 400,
          maxWidth: 440, lineHeight: 1.65,
          margin: "24px 0 40px",
        }}>
          This section of LifeDesk is actively being built.
          Check back shortly — it won't be long.
        </p>

        {/* CTA */}
        <button
          onClick={() => navigate("/app")}
          style={{
            background: "#2563EB", color: "#fff", border: "none",
            borderRadius: 11, padding: "14px 28px",
            fontWeight: 700, fontSize: 15, cursor: "pointer",
            fontFamily: "inherit", display: "inline-flex", alignItems: "center", gap: 10,
            boxShadow: "0 4px 16px rgba(37,99,235,.3)",
            transition: "transform .15s, box-shadow .15s",
          }}
          onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-1px)"; e.currentTarget.style.boxShadow = "0 6px 20px rgba(37,99,235,.4)"; }}
          onMouseLeave={e => { e.currentTarget.style.transform = ""; e.currentTarget.style.boxShadow = "0 4px 16px rgba(37,99,235,.3)"; }}
        >
          Go to the app <span style={{ fontSize: 16 }}>→</span>
        </button>

      </div>

      {/* Footer line */}
      <div style={{ textAlign: "center", padding: "20px 0 32px", fontSize: 13, color: "#CBD5E1" }}>
        © {new Date().getFullYear()} LifeDesk
      </div>

    </div>
  );
}
